<template>
  <div class="text-center">
    <v-menu offset-y absolute v-model="lmenu" :close-on-content-click="false" :full-width="true">
      <v-btn :depressed="true" slot="activator" block>
        <span v-if="conservationGuests === 0" class="caption">Number of Guests</span>
        <span v-if="conservationGuests >= 1" class="caption">{{conservationGuests}} Guests</span>
      </v-btn>
      <v-list>
        <v-list-tile row v-for="(guest, key) in allConservationFees" :key="key">
          <v-container>
            <v-layout row>
              <v-flex lg6 md6 sm6 xs6 align-left>
                <p class="body-2" :title="guest.payment_person_description" v-tippy>{{guest.payment_person}} ({{guest.payment_person_currency}} {{guest.payment_person_amount}})</p>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="reduceGuest(key)" dark round small color="error"><v-icon>remove</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <h4 class="text-md-center text-sm-center text-xs-center">{{allConservationFees[key].payment_guests}}</h4>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="addGuest(key)" dark round small color="primary"><v-icon>add</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <v-list-tile>
          <v-container>
            <v-layout row wrap>
              <v-flex md4 lg4 sm4 xs12 offset-lg7 offset-md7 offset-sm7 align-center>
                <v-btn :depressed="true" dark small block color="primary" @click="lmenu = false">Apply</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <br>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'Guests',
    data() {
      return {
        lmenu: false
      }
    },
    created() {
      if (JSON.parse(localStorage.getItem('conservation_data')).length !== 0) {
        this.$store.commit('LOCAL_CONSERVATION', JSON.parse(localStorage.getItem('conservation_data')))
      }
      // Commented out due to the request being made when the check-in date is selected
      // else {
      //   this.$store.dispatch('get_all_conservation_fees')
      // }
    },
    methods: {
      calculatedAdults: function () {
        this.peopleSelected.adults = Number(this.peopleSelected.citizenAdults) + Number(this.peopleSelected.residentAdults) + Number(this.peopleSelected.nonResidentAdults)
      },
      calculatedChildren: function () {
        this.peopleSelected.children = Number(this.peopleSelected.infants) + Number(this.peopleSelected.citizenChildren) + Number(this.peopleSelected.residentChildren) + Number(this.peopleSelected.nonResidentChildren)
      },
      reduceGuest: function (key) {
        var guest = this.allConservationFees[key].payment_guests
        if (guest > 0) {
          guest = Number(guest) - 1
          this.allConservationFees[key].payment_guests = guest
        }
      },
      addGuest: function (key) {
        var guest = this.allConservationFees[key].payment_guests
        guest = Number(guest) + 1
        this.allConservationFees[key].payment_guests = guest
      }
    }
  }
</script>

<style scoped>
</style>
